import { render, staticRenderFns } from "./TableUndo.vue?vue&type=template&id=c4799b02&scoped=true&"
import script from "./TableUndo.vue?vue&type=script&lang=js&"
export * from "./TableUndo.vue?vue&type=script&lang=js&"
import style0 from "./TableUndo.vue?vue&type=style&index=0&id=c4799b02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4799b02",
  null
  
)

export default component.exports